import { useState } from 'react';
import { useSim } from '../state/sim';
import { SimToggle } from './SimToggle';
import { WakeToggle } from './WakeToggle';
import { SoundToggle } from './SoundToggle';

/** In-round settings cluster. Sim / Screen / Sound used to be three stacked pills
 *  that sat on top of the cockpit + incoming banner on a phone (playtest fix);
 *  they now collapse behind one narrow chip and drop down as a dismissible panel,
 *  so the live HUD is never covered. A scrim closes it on an outside tap. */
export function HudControls() {
  const [open, setOpen] = useState(false);
  const sim = useSim(); // reactive → the chip shows a live dot while the sim is on
  return (
    <div className="hud-controls" data-testid="hud-controls">
      {open && <div className="hud-controls__scrim" onClick={() => setOpen(false)} />}
      <button
        className="hud-controls__toggle"
        data-open={open}
        data-active={sim.enabled}
        data-testid="hud-controls-toggle"
        aria-expanded={open}
        aria-label="Game controls: simulator, screen, sound"
        onClick={() => setOpen((o) => !o)}
      >
        <SlidersIcon />
        <span className={`dot ${sim.enabled ? 'dot--signal' : ''}`} />
      </button>
      {open && (
        <div className="hud-controls__panel" data-testid="hud-controls-panel">
          <SimToggle />
          <WakeToggle />
          <SoundToggle />
        </div>
      )}
    </div>
  );
}

function SlidersIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <rect x="2" y="3" width="12" height="1.5" rx="0.75" />
      <circle cx="11" cy="3.75" r="2.1" />
      <rect x="2" y="7.25" width="12" height="1.5" rx="0.75" />
      <circle cx="5" cy="8" r="2.1" />
      <rect x="2" y="11.5" width="12" height="1.5" rx="0.75" />
      <circle cx="10" cy="12.25" r="2.1" />
    </svg>
  );
}
